export default function PublicProfileController() {}
